import moment from 'locale/momentLocale'
import PropTypes from 'prop-types'
import React from 'react'

const Date = ({ date }) => <span className="store-result-date">{moment(date).format('dd D.M')}</span>

Date.propTypes = {
  date: PropTypes.string.isRequired,
}

export default Date
